import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { TagColor, TagType } from '@freelancer/ui/tag';

@Component({
  standalone: true,
  imports: [CommonModule, TrackingModule, UiModule],
  selector: 'app-ai-consultant-suggested-message',
  template: `
    <fl-tag
      class="SuggestedMessageTag"
      flTrackingSection="AiConsultantWidget-SuggestedMessage"
      flTrackingLabel="SuggestedMessageTag"
      [color]="TagColor.INHERIT"
      [type]="TagType.CLICKABLE"
      [flMarginRight]="'xsmall'"
      [flMarginBottom]="'xsmall'"
      (click)="handleClick()"
    >
      {{ message }}
    </fl-tag>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./ai-consultant-suggested-message.component.scss'],
})
export class AiConsultantSuggestedMessageComponent {
  TagColor = TagColor;
  TagType = TagType;

  @Input() message: string;
  @Output() messageClicked = new EventEmitter<string>();

  handleClick(): void {
    this.messageClicked.emit(this.message);
  }
}
